import { client } from "./client";

// Perfis (profiles)
export const listProfiles = () => client.get("account_profiles.json");
export const createProfile = profile => client.post("account_profiles.json", { profile });
export const updateProfile = (id, profile) => client.patch(`account_profiles/${id}.json`, { profile });
export const deleteProfile = id => client.delete(`account_profiles/${id}.json`);
export const duplicateProfile = id => client.post(`account_profiles/${id}/duplicate.json`);

// Operadores (operators)
export const listOperators = () => client.get("operators.json");
export const createOperator = params => client.post("operators.json", params);
export const updateOperator = (id, params) => client.patch(`operators/${id}.json`, params);
export const deleteOperator = id => client.delete(`operators/${id}.json`);
